import React from 'react';
import Search from './components/Search';
import CreateBtn from './components/CreateBtn';
import UnassignedVideosCheckBox from './components/UnassignedVideosCheckBox';
import ResetBtn from './components/ResetBtn';
import SortBy from './components/SortBy/SortBy';
import CountOfItem from './components/CountOfItem';
import WithURLFilters from './components/WithURLFilters';
import CategorySelect from './components/CategorySelect';
import StudioSelect from './components/StudioSelect';
import AssignmentBtn from './components/AssignmentBtn';
import VideosCategoriesBtn from './components/VideosCategoriesBtn';
import StudiosBtn from './components/StudiosBtn';
import style from './VideosControlPanel.module.scss';

const VideosControlPanel: React.FC = () => {
	return (
		<WithURLFilters>
			<div className={style.firstRowWithControls}>
				<Search />
				<CreateBtn />
				<AssignmentBtn />
				<VideosCategoriesBtn />
				<StudiosBtn />
			</div>
			<div className={style.secondRowWithControls}>
				<div className={style.selectWrapper}>
					<StudioSelect />
					<CategorySelect />
					<UnassignedVideosCheckBox />
				</div>
				<div className={style.verticalAlignBlock}>
					<ResetBtn />
					<SortBy />
					<CountOfItem />
				</div>
			</div>
		</WithURLFilters>
	);
};

export default VideosControlPanel;
